import React from 'react';
import { useSelector } from 'react-redux';
import { selectUiState } from '../../redux/slices/ui';
import PaymentV2 from './payment-v2';
import Payment from './index';
import GuestShell from '../guest-shell';

const PaymentSwitch = props => {
  const ui = useSelector(selectUiState);

  return ui.isBookingEngine ? (
    <GuestShell
      activeTab="payments"
      bookingCode={props.match.params.booking_code}
    >
      <PaymentV2 {...props} />
    </GuestShell>
  ) : (
    <Payment {...props} />
  );
};

export default PaymentSwitch;
